// Default Settings
var markerIcons = {
      active: {},
      inactive: {}
};
const markers = [];

export function renderPlacesOfInterest(poiData, globals) {
    poiData.forEach(poi => {  
        var icon = poi.pinImageUrl && poi.pinImageUrl !== ""
            ? {
                url: poi.pinImageUrl,
                size: new google.maps.Size(25, 25),
                scaledSize: new google.maps.Size(25, 25)
            } : null;

        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(poi.lat, poi.lng),
            map: globals.map,
            icon: icon ? icon : markerIcons.inactive
        });
  
        // Attach click event to the marker...
        (function (marker, poi) {
            google.maps.event.addListener(marker, "click", function (e) {
                const contentString = infoWindowMarkup(poi)
                globals.showHideInfoWindow(marker, contentString);
            });
        })(marker, poi);
  
        markers.push(marker);
    });

    google.maps.event.addListener(globals.map, 'zoom_changed', function() {
        const iconSizeAt15 = 25;
        const zoomLevel = globals.map.getZoom();

        // Check if the current zoom level is more than or less than.
        let iconSize = iconSizeAt15;
        if (zoomLevel > 15) {
            iconSize = Math.round(iconSizeAt15 * Math.pow(1.25, zoomLevel - 15));
        }
        else if (zoomLevel < 15) {
            iconSize = Math.round(iconSizeAt15 / Math.pow(1.25, 15 - zoomLevel));
        }

        // Iterate between all markers and set the size
        markers.forEach(marker => {
            if (marker.getIcon()) {
                marker.setIcon({
                    url: marker.getIcon().url,
                    size: new google.maps.Size(iconSize, iconSize),
                    scaledSize: new google.maps.Size(iconSize, iconSize),
                });
            }            
        });
    });
}

function infoWindowMarkup(poi) {
    let html = '';   
    
    // Set the image // TODO check if POI needs to add a GTM thing here to handle the (Select Item from Map) event which is supposed to happen on click on the thumbnail or more info button on map view (product-info__elevation)
    var image = poi.pageUrl 
        ? ('<a class="product-info__elevation" href="' + poi.pageUrl + '" style="background-image:url(' + poi.imageUrl + ')"></a>')
        : ('<div class="product-info__elevation" style="background-image:url(' + poi.imageUrl + ')"></div>');

    // Set the header
    var header = (
        '<h4 class="product-info__name">' + poi.name + '</h4>'
    );
   
    // Set the link  // TODO check if POI needs to add a GTM thing here to handle the (Select Item from Map) event which is supposed to happen on click on the thumbnail or more info button on map view (product-info__more)
    var link = '<div class="product-info__more">&nbsp;</div>';
    if(poi.pageUrl && poi.pageUrl !== '') {
        link = (
            '<div class="product-info__more">' +
                '<a href="' + poi.pageUrl + '" target="_blank" class="product-info__more-information mdl-button mdl-js-button mdl-button--raised mdl-button--colored">' + poi.ctaText + '</a>' +
            '</div>'
        );
    }

    // Set the HTML
    html = (
        '<div class="estate-info product-info">' +
            image +
            '<div class="product-info__details">' +
                header +
                '<div class="product-info__details-text">' + poi.description + '</div>' +
                link +
            '</div>' +
        '</div>'
    );
   
    // Create final card html and return
    let cardHTML = (
        '<div class="product-info__window">' +
            '<div class="product-info__wrapper">' +
                '<div class="product-info__container">' +
                    html +
                '</div>' +
            '</div>' +
        '</div>'
    );
   
    return cardHTML;   
}

export const deactivatePlacesOfInterestMarkers = () => {
    markers.forEach(marker => marker.setIcon(markerIcons.inactive));
}